import React from 'react';
import PropTypes from 'prop-types';

/**
 * SocialShare component renders social sharing icons for a given post.
 * Designed to be clean, scalable, and easy to maintain in enterprise-grade apps.
 */
const SocialShare = ({ link, title }) => {
    if (!link || !title) {
        return null;
    }

    const encodedLink = encodeURIComponent(link);
    const encodedTitle = encodeURIComponent(title);

    const shareUrls = {
        facebook: `https://www.facebook.com/sharer.php?u=${encodedLink}&t=${encodedTitle}`,
        twitter: `https://twitter.com/intent/tweet?url=${encodedLink}&text=${encodedTitle}`,
        linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedLink}&title=${encodedTitle}`,
        whatsapp: `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedLink}`,
    };

    return (
        <ul className="social-share-list">
            <li className="share-item facebook">
                <a href={shareUrls.facebook} target="_blank" rel="noopener noreferrer" title="Share on Facebook">
                    fb.
                </a>
            </li>
            <li className="share-item twitter">
                <a href={shareUrls.twitter} target="_blank" rel="noopener noreferrer" title="Share on Twitter">
                    tw.
                </a>
            </li>
            <li className="share-item linkedin">
                <a href={shareUrls.linkedin} target="_blank" rel="noopener noreferrer" title="Share on LinkedIn">
                    li.
                </a>
            </li>
            <li className="share-item whatsapp">
                <a href={shareUrls.whatsapp} target="_blank" rel="noopener noreferrer" title="Share on WhatsApp">
                    wa.
                </a>
            </li>
        </ul>
    );
};

SocialShare.propTypes = {
    link: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

export default SocialShare;
